import { Link, useLocation } from 'react-router-dom';

import { cn } from '@/helpers/shadcn';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/app/ui/hover-card';

// Slack-style: the recents flyout is a mouse-only convenience that opens after a hover
// and closes on leave. It deliberately does NOT open on keyboard focus — keyboard users
// get a plain navigating link — so the trigger's focus is stopped before HoverCard sees
// it. The panel is only mounted while open, so its data hook fetches lazily on first hover.
const preventFocusOpen = (event) => event.preventDefault();

const NavFlyout = ({ to, label, icon: Icon, testId, Panel }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(to);

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Link
          to={to}
          data-testid={testId}
          data-active={isActive}
          onFocus={preventFocusOpen}
          className={cn(
            'relative flex size-11 items-center justify-center rounded-xl text-muted-foreground transition-colors ',
            isActive && 'bg-primary/10 dark:bg-secondary/10 text-primary dark:text-secondary',
            !isActive && 'hover:bg-accent hover:text-foreground',
            'data-[state=open]:bg-accent data-[state=open]:text-primary'
          )}
        >
          <Icon className="size-5" />
          <span className="sr-only">{label}</span>
        </Link>
      </HoverCardTrigger>
      {/* The panel supplies its own card chrome, so this content wrapper stays
          unstyled and lazily mounts the recent-list hook only while open. */}
      <HoverCardContent side="right" align="start" sideOffset={12} className="w-auto rounded-none border-0 bg-transparent p-0 shadow-none">
        <Panel />
      </HoverCardContent>
    </HoverCard>
  );
};

export default NavFlyout;
